import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#0A192F] text-white grid place-items-center px-6 grain">
      <div className="w-full max-w-md relative">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors mb-8" data-testid="admin-back">
          <ArrowLeft size={16} /> Back to website
        </Link>
        <span className="label text-white/40">Catalyst Solutions</span>
        <h1 className="font-display text-4xl mt-3 mb-8">Admin Sign In</h1>
        <form onSubmit={submit} className="bg-white/[0.04] border border-white/10 rounded-3xl p-8 backdrop-blur-xl space-y-5" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label className="label text-[0.55rem] text-white/50">Email</Label>
            <Input data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@drsangeetaroy.com" className="h-12 bg-white/5 border-white/15 text-white placeholder:text-white/30" />
          </div>
          <div className="space-y-2">
            <Label className="label text-[0.55rem] text-white/50">Password</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-12 bg-white/5 border-white/15 text-white placeholder:text-white/30" />
          </div>
          {error && <p className="text-red-300 text-sm" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-white text-[#0A192F] py-3.5 font-medium hover:bg-white/90 transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
